// extracted by mini-css-extract-plugin
module.exports = {"list":"TagsList_list__2v0JV"};